import { compose, withState } from 'recompose'
import App from './App'
import BaseComponent from './BaseComponent'
import React from 'react'
import firebase from 'firebase'

export default compose(
	withState('user', 'setUser'),
	withState('loading', 'setLoading', true)
)(
	class AppContainer extends BaseComponent {
		constructor() {
			super()
			const config = {
				/* eslint-disable no-process-env */
				apiKey: process.env.REACT_APP_FIREBASE_apiKey,
				authDomain: process.env.REACT_APP_FIREBASE_authDomain,
				databaseURL: process.env.REACT_APP_FIREBASE_databaseURL,
				projectId: process.env.REACT_APP_FIREBASE_projectId,
				storageBucket: process.env.REACT_APP_FIREBASE_storageBucket,
				messagingSenderId: process.env.REACT_APP_FIREBASE_messagingSenderId
			}
			firebase.initializeApp(config)
		}

		componentDidMount() {
			firebase.auth().onAuthStateChanged(user => {
				this.props.setUser(user)
				this.props.setLoading(false)
			})
		}

		render() {
			return <App user={this.props.user} loading={this.props.loading} />
		}
	}
)



// WEBPACK FOOTER //
// ./src/AppContainer.js